import { GOOGLE_REVIEWS_URL, REVIEW_WRITE_URL, REVIEWS } from "./data";
import { Chapter, Rise } from "./motion";

const ROTS = ["lg:-rotate-2", "lg:rotate-1", "lg:-rotate-1"];

const Reviews = () => (
  <section
    id="reviews"
    data-testid="reviews-section"
    className="border-b-2 border-ink bg-paper"
  >
    <div className="mx-auto max-w-[1500px] px-4 py-20 sm:px-6 lg:py-28">
      <Rise>
        <Chapter num="06" label="Reviews" />
      </Rise>
      <div className="mt-6 flex flex-wrap items-end gap-x-8">
        <Rise delay={0.05}>
          <span className="font-display text-[8rem] leading-[0.7] text-polered sm:text-[12rem]">
            &ldquo;
          </span>
        </Rise>
        <Rise delay={0.1}>
          <h2 className="font-display text-[11vw] uppercase leading-[0.85] sm:text-7xl lg:text-8xl">
            The people
            <br />
            have spoken.
          </h2>
        </Rise>
      </div>

      <Rise delay={0.15}>
        <a
          href={GOOGLE_REVIEWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-reviews-link"
          className="mt-10 inline-flex flex-wrap items-center gap-x-4 gap-y-2 border-2 border-ink bg-ink px-6 py-4 text-paper shadow-hard-sm transition-transform duration-150 hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-none"
        >
          <span className="font-display text-3xl uppercase leading-none">
            4.7 <span className="text-polered">★</span>
          </span>
          <span className="font-mono2 text-[11px] font-bold uppercase tracking-[0.25em] text-paper/70">
            Rated on Google — read the reviews
          </span>
        </a>
      </Rise>

      <div className="mt-16 grid grid-cols-1 gap-10 md:grid-cols-3 lg:gap-8">
        {REVIEWS.map((r, i) => (
          <Rise key={r.author} delay={0.1 * i} className={ROTS[i]}>
            <blockquote
              data-testid={`review-card-${i}`}
              className="relative h-full border-2 border-ink bg-cream p-8 pt-12 shadow-hard"
            >
              <div className="tape -top-3 left-8 -rotate-6" />
              <div
                className="font-display text-xl tracking-[0.2em] text-polered"
                aria-label="5 star review"
              >
                ★★★★★
              </div>
              <p className="mt-5 text-xl font-medium leading-snug">
                &ldquo;{r.quote}&rdquo;
              </p>
              <footer className="mt-6 border-t border-dashed border-ink/30 pt-4 font-mono2 text-[11px] font-bold uppercase tracking-[0.25em] text-ink/60">
                — {r.author}
              </footer>
            </blockquote>
          </Rise>
        ))}
      </div>

      <Rise delay={0.2}>
        <div className="mt-14 flex justify-center">
          <a
            href={REVIEW_WRITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="leave-review-button"
            className="inline-flex items-center gap-3 border-2 border-ink bg-polered px-8 py-5 font-display text-2xl uppercase tracking-wide text-paper shadow-hard transition-transform duration-150 hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-none"
          >
            <span aria-hidden="true">★</span> Leave us a Google review
          </a>
        </div>
      </Rise>
    </div>
  </section>
);

export default Reviews;
